export default "<p>platform-setup works!</p>\r\n"